import { useState } from "react";
import objectToOption from "../InputPointer/objectToOption";
import RelationDialog from "nq-component/dist/RelationDialog";
import React from "react";
import filterFields from "nq-component/dist/filterFields";
import GetOption from "../InputPointer/GetOption";
import { Select } from "antd";

const defaultProps = {
  includes: [],
};

function AntRelation({
  schema,
  object,
  pick,
  target,
  onChange,
  where,
  indexes,
  field,
  defaultValue,
  findObject,
  saveObject,
  saveFile,
  saveImage,
  schemas,
  keys,
  dynamic,
  sort,
  includes,
  ...props
}) {
  const [value, setValue] = useState([]);
  const [options, setOptions] = useState([]);
  const prevValueRef = React.useRef([]);

  // indexes use for display
  const _indexes = React.useMemo(() => {
    const items = indexes || filterFields(schema.fields, "_index");
    // if no index use name
    return items.length > 0 ? items : ["name"];
  }, [schema]);

  // keys use for selected keys for query
  const _keys = React.useMemo(() => {
    const items = keys || filterFields(schema.fields, "key");
    return items;
  }, [schema]);

  // Set initial value and update prevValueRef only once
  React.useEffect(() => {
    if (defaultValue) {
      const formatted = defaultValue.map((obj) =>
        objectToOption(obj, _indexes)
      );
      setValue(formatted);
      prevValueRef.current = formatted;
    }
  }, [_indexes, defaultValue]);

  function callback(fetchedOptions) {
    setOptions(fetchedOptions);
  }

  // load the initial select options
  React.useEffect(() => {
    new GetOption(
      target,
      "",
      _indexes,
      findObject,
      where,
      callback,
      _keys,
      sort,
      includes
    );
  }, [target, _indexes]);

  function _onChange(selectedValues) {
    // Merge options and current value to ensure selected items are always resolvable
    const allOptions = [
      ...options,
      ...value.filter((v) => !options.find((o) => o.value === v.value)),
    ];

    const selectedOptions = selectedValues
      .map((val) => allOptions.find((opt) => opt.value === val))
      .filter(Boolean);

    const prevValues = prevValueRef.current.map((v) => v.value);
    const currentValues = selectedOptions.map((v) => v.value);

    const added = currentValues.filter((val) => !prevValues.includes(val));
    const removed = prevValues.filter((val) => !currentValues.includes(val));

    if (added.length > 0) {
      if (props.addedObject) {
        added.forEach((item) => {
          props.addedObject(item);
        });
      }
    }

    if (removed.length > 0) {
      if (props?.deletedObject) {
        removed.forEach((item) => {
          props?.deletedObject(item);
        });
      }
    }

    // Update both state and ref so display stays in sync
    setValue(selectedOptions);
    prevValueRef.current = selectedOptions;

    onChange(selectedOptions.map((o) => o.object));
  }

  function onSearch(word) {
    new GetOption(
      target,
      word,
      _indexes,
      findObject,
      where,
      setOptions,
      _keys,
      sort,
      includes
    );
  }

  function getValue() {
    return value.map((v) => v.value);
  }

  function getOptions() {
    // Include all fetched options PLUS any selected values not yet in options
    // (e.g. from defaultValue that weren't in the initial fetch)
    const selectedNotInOptions = value.filter(
      (v) => !options.find((o) => o.value === v.value)
    );
    return [...options, ...selectedNotInOptions];
  }

  return (
    <Select
      mode="multiple"
      className="mb-3"
      allowClear
      size="large"
      value={getValue()}
      onChange={_onChange}
      options={getOptions()}
      style={{ width: "100%" }}
      onSearch={onSearch}
      showSearch
      filterOption={false}
      {...props}
    />
  );
}

AntRelation.defaultProps = defaultProps;
export default AntRelation;